module.exports = __webpack_public_path__ + "media/images/app/law-db38a7800fac421b7f6bed7e36832354.svg";